module.exports = __webpack_public_path__ + "img/product-3-shawwer.8571826e.png";